import moment, { Moment } from 'moment';

import { Palette } from '@utils/types';
import { HotelRoomStatusType, CheckAvailabilityViewModel } from '@api/index';
import {
  formatISOToDate,
  URL_DATE_FORMAT,
  getCurrentDate,
  getNMonthsLater,
  isInclusivelyAfterDay,
} from '@utils/dateUtil';

import { CalenderDay, CalenderEventDay } from './styled';

// ======================================
// Get the color base on date type
// ======================================
export const getDateColor = (
  palette: Palette,
  dateType?: HotelRoomStatusType
) => {
  if (!dateType) return palette.darkGrey;

  switch (dateType) {
    case HotelRoomStatusType.ASK_SELL:
      return palette.yellow;
    case HotelRoomStatusType.OPEN_SALE:
      return palette.darkSuccess;
    case HotelRoomStatusType.CLOSE_SALE:
      return palette.red;

    default:
      return palette.darkGrey;
  }
};

export const renderEvents = (
  day: moment.Moment,

  events: { items: any[] }
) => {
  let eventDay = null;

  events?.items?.forEach((date) =>
    date.start.date === day.format('YYYY-MM-DD') ? (eventDay = date) : date
  );

  return (
    <CalenderDay style={{ color: 'black' }}>
      {day.date()}
      {eventDay ? <CalenderEventDay /> : null}
    </CalenderDay>
  );
};

// ======================================
// Render Events and Available Dates
// ======================================
export const renderEventsAndAvailableDates = (
  day: moment.Moment,
  palette: Palette,
  events: { items: any[] },
  data?: CheckAvailabilityViewModel
) => {
  let textColor = palette.darkGrey;
  let eventDay = null;
  data?.availabilityList?.forEach((availableItem) => {
    if (
      day.format(URL_DATE_FORMAT) ===
        formatISOToDate(availableItem.date, URL_DATE_FORMAT) &&
      availableItem.roomStatus
    )
      textColor = getDateColor(palette, availableItem.roomStatus);
  });

  events?.items?.forEach((date) =>
    date.start.date === day.format('YYYY-MM-DD') ? (eventDay = date) : date
  );

  return (
    <CalenderDay style={{ color: textColor }}>
      {day.date()}
      {eventDay ? <CalenderEventDay /> : null}
    </CalenderDay>
  );
};

// ======================================
// Get one month dates  selection range
// ======================================
export const getOneMonthDatesRange = (
  day: Moment,
  startDate: Moment | null,
  endDate: Moment | null
): boolean =>
  !isInclusivelyAfterDay(day, getCurrentDate()) ||
  (startDate
    ? !endDate
      ? isInclusivelyAfterDay(day, getNMonthsLater(startDate, 1))
      : false
    : false);
